import StoryEditor from './StoryEditor.vue';

export default StoryEditor;
